import React, { useState } from 'react';
import { Company } from '../../services/semantic-search.service';
import CompanyModal from './CompanyModal';
import { Message } from '../../services/openai.service';

interface CompanyCardsProps {
  companies: Company[];
  onCompanySelect?: (companyId: string, companyName: string) => void;
  conversationHistory?: Message[];
  serviceName?: string;
  categoryName?: string;
  cityName?: string;
}

const CompanyCards: React.FC<CompanyCardsProps> = ({ companies, onCompanySelect, conversationHistory, serviceName, categoryName, cityName }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState<string | null>(null);

  if (!companies || companies.length === 0) {
    return null;
  }

  const handleViewCompany = (companyId: string) => {
    setSelectedCompanyId(companyId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleApproveCompany = (companyId: string, companyName: string) => {
    if (onCompanySelect) {
      onCompanySelect(companyId, companyName);
    }
    setIsModalOpen(false);
  };

  return (
    <div className="my-3 w-full">
      <h3 className="text-sm font-medium text-xervix-text-muted dark:text-xervix-text-muted-dark mb-2">
        Profesionales disponibles:
      </h3>
      <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 gap-3">
        {companies.map((company) => (
          <div
            key={company.companyId}
            className="bg-xervix-bg-tertiary dark:bg-xervix-bg-tertiary-dark rounded-lg p-4 flex flex-col items-center text-center"
          >
            {/* Imagen de perfil */}
            <div className="w-16 h-16 rounded-full overflow-hidden mb-3">
              {company.profileImage ? (
                <img
                  src={company.profileImage}
                  alt={`${company.name} ${company.lastName}`}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-xervix-primary flex items-center justify-center text-white">
                  <span className="text-lg font-bold">{company.name.charAt(0)}</span>
                </div>
              )}
            </div>

            {/* Nombre de la empresa */}
            <h4 className="font-medium text-xervix-text-primary dark:text-xervix-text-primary-dark mb-3">
              {company.name} {company.lastName}
            </h4>

            {/* Botón Ver empresa */}
            <button
              onClick={() => handleViewCompany(company.companyId)}
              className="mt-auto w-full bg-xervix-primary hover:bg-xervix-primary-dark text-white text-sm font-medium py-2 px-4 rounded transition-colors"
            >
              Ver empresa
            </button>
          </div>
        ))}
      </div>

      {/* Modal de información detallada */}
      <CompanyModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        company={companies.find(c => c.companyId === selectedCompanyId)}
        onApprove={handleApproveCompany}
        conversationHistory={conversationHistory}
        serviceName={serviceName}
        categoryName={categoryName}
        cityName={cityName}
      />
    </div>
  );
};

export default CompanyCards;
